import { Plane, Compass, Package, Trophy, MessageCircle, Globe, ArrowRight } from "lucide-react";
import { Stagger, StaggerItem } from "@/components/motion";

const ICONS = { Plane, Compass, Package, Trophy, MessageCircle, Globe };

// Rejilla de "capas" (actos) con imagen del dúo + marca/patrocinador y CTA por acto
export const ActLayers = ({ acts, onSelect }) => {
  const go = (a) => {
    if (onSelect) onSelect(a);
    const el = document.getElementById("contacto");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Stagger className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="act-layers">
      {acts.map((a) => {
        const Icon = ICONS[a.icon] || Plane;
        const lightText = a.dark || a.color === "#FF8A80";
        const textCls = lightText ? "text-white" : "text-ink";
        const subCls = lightText ? "text-white/85" : "text-ink/70";
        const btnCls = lightText
          ? "bg-white/20 text-white hover:bg-white/30"
          : "bg-ink/10 text-ink hover:bg-ink/20";
        return (
          <StaggerItem
            key={a.n}
            data-testid={`act-card-${a.n}`}
            className="flex flex-col overflow-hidden rounded-[1.75rem] shadow-[0_12px_36px_rgb(0,0,0,0.08)]"
          >
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src={a.img}
                alt={`Anto y Bella con una marca en el acto ${a.n}`}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 hover:scale-105"
              />
            </div>
            <div className="flex flex-1 flex-col p-6" style={{ backgroundColor: a.color }}>
              <div className="flex items-center justify-between">
                <span className={`flex h-10 w-10 items-center justify-center rounded-xl ${lightText ? "bg-white/20" : "bg-white/50"}`}>
                  <Icon className={`h-5 w-5 ${textCls}`} strokeWidth={2.2} />
                </span>
                <span className={`font-mono text-xs uppercase tracking-[0.25em] ${subCls}`}>
                  Acto {a.n}
                </span>
              </div>
              <h3 className={`mt-5 font-display text-2xl font-extrabold tracking-tight ${textCls}`}>
                {a.title}
              </h3>
              <p className={`mt-3 flex-1 text-sm leading-relaxed ${subCls}`}>{a.desc}</p>
              <button
                type="button"
                onClick={() => go(a)}
                data-testid={`act-cta-${a.n}`}
                className={`group mt-6 inline-flex items-center justify-center gap-2 rounded-full px-5 py-3 text-sm font-semibold transition-all duration-300 ${btnCls}`}
              >
                Me interesa este acto
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </button>
            </div>
          </StaggerItem>
        );
      })}
    </Stagger>
  );
};
